import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { FormControl, FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown'
import { CommonModule } from '@angular/common';
import { TranslationService } from '../Services/translation.service';
import { AuthService } from '../Services/auth.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MaterialModule } from '../material';
import { Router } from '@angular/router';
import { ApiService } from '../Services/api.service';
import { ToastService } from '../Services/toast.service';
import { ButtonModule } from 'primeng/button';
import { MatButtonModule } from '@angular/material/button';
import { trigger, transition, style, animate, query, stagger } from '@angular/animations';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
declare var bootstrap: any; // since you’re using Bootstrap from CDN

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [InputTextModule, DropdownModule, FormsModule, CommonModule, TranslateModule, MaterialModule,
    MatButtonModule],
  providers: [AuthService, ApiService, ToastService, TranslateService],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  animations: [
    trigger('listAnimation', [
      transition(':enter', [
        query('li', [
          style({ opacity: 0, transform: 'translateX(20px)' }),
          stagger(100, [
            animate('300ms ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
          ])
        ], { optional: true })
      ])
    ])
  ],
})
export class HeaderComponent implements OnInit {
  @ViewChild('offcanvasRight') offcanvasElement!: ElementRef;
offcanvasInstance: any;
locale: string;
  searchCard = new FormControl('');
  searchClaim = new FormControl('');
  providerID: string;
  loading: boolean | false;
  isLoadingforCard: boolean | false;
  claimDetails: any;
  claimNumber: string;
  isOpen: boolean = false;
  isOffcanvasOpen = false;
  allNotifications: any[] = [];
  pageSize = 5;
  currentPage = 1;
  unreadCount: number = 0;

  constructor(public translationService: TranslationService, private authService: AuthService, private router: Router, private apiService: ApiService<any>, private toastService: ToastService, private translateService: TranslateService, private renderer: Renderer2) { }

  ngOnInit(): void {
    this.locale = localStorage.getItem('lang');
    this.providerID = this.authService.getCurrentUserPID();
    this.getAllNotifications();
  }



  selectedLanguage = this.translationService.getCurrentLanguage();

  languages = [
    { code: 'en', name: 'English' },
    { code: 'ar', name: 'العربية' }
  ];

  getFlag(code: string) {
    return code === 'en' ? 'https://flagcdn.com/w20/gb.png' : 'https://flagcdn.com/w20/ly.png';
  }


changeLanguage(lang: string) {
  const offcanvasEl = this.offcanvasElement?.nativeElement;
  const offcanvasInstance = offcanvasEl ? bootstrap.Offcanvas.getInstance(offcanvasEl) : null;

  if (offcanvasInstance) {
    offcanvasInstance.hide();
  }
  this.translationService.setLanguage(lang);
  this.selectedLanguage = lang;
  localStorage.setItem('lang', lang);

  setTimeout(() => {
    this.locale = lang;
  }, 300); 
}


  logout() {
    this.authService.logout()
  }

  get totalPages(): number {
    return Math.ceil(this.allNotifications.length / this.pageSize);
  }

  get paginatedNotifications() {
    if (!this.allNotifications) return [];
    const start = (this.currentPage - 1) * this.pageSize;
    return this.allNotifications.slice(start, start + this.pageSize);
  }

  nextPage() {
    if (this.currentPage < this.totalPages) this.currentPage++;
  }

  prevPage() {
    if (this.currentPage > 1) this.currentPage--;
  }

  toggleEnvelope(notification: any) {
    this.apiService.create(`api/Notifications/MarkNotificationAsRead?notificationId=${notification}&providerId=${this.providerID}`).subscribe({
      next:(response:any)=> {
          this.getAllNotifications()
      },
      error: (error: any) => {
        this.toastService.showError(error)
      }
    })
  }

  public  getAllNotifications() {
    this.apiService.getAll(`api/Notifications/GetAllNotifications?providerId=${this.providerID}`).subscribe({
      next: (response: any) => {
        this.allNotifications = response.successResponse.sort(
          (a: any, b: any) => new Date(b.notificationCreatedOn).getTime() - new Date(a.notificationCreatedOn).getTime()
        );
        this.unreadCount = this.allNotifications.filter(n => n.isRead === 0 || n.isRead === null).length;
        this.currentPage = 1;
      },
      error: (error: any) => {
        this.toastService.showError(error);
      }
    });
  }

  searchByCard() {
    this.isLoadingforCard = true
    const cardNumber = this.searchCard.value;
    if (!cardNumber) {
      this.translateService.get('toast.pleaseenterassuredid').subscribe(text => this.toastService.showWarn(text));
      this.isLoadingforCard = false
      return;
    }
    this.isLoadingforCard = true;
    this.router.navigate(['/portal/searchid', cardNumber]).then(() => {
      setTimeout(() => {
        this.isLoadingforCard = false;
        this.searchCard.setValue('');
      }, 500);
    }).catch(() => {
      this.isLoadingforCard = false;
    });
  }


  getClaimdata() {
    this.loading = true;
    const claimNumber = this.searchClaim?.value.trim();
    if (!claimNumber) {
      this.translateService.get('toast.pleaseenterclaimnumber').subscribe(text => this.toastService.showWarn(text));
      this.loading = false
      return;
    }
    this.apiService.getAll(`api/Claim/GetClaimDataWithClaimType?claimNumber=${claimNumber}&providerID=${this.providerID}`).subscribe({
      next: (response: any) => {
        this.loading = false;
        this.claimDetails = response.successResponse;
        if (this.claimDetails.typeOfClaim === 1 || this.claimDetails.typeOfClaim === null) {
          this.router.navigate(['/portal/insert-claim/create-medication', claimNumber])
        } else {
          this.router.navigate(['/portal/insert-claim/create-chronic-medication', claimNumber])
        }
      },
      error: (err: any) => {
        this.loading = false;
        this.toastService.showError(err);
      }
    });
  }

}
